import {
  mockCmsFooter,
  mockCmsHeader,
  mockCmsSeoSite,
} from '@domgen/dgx-fe-cms';
import { CmsSelfFixRoot } from '../../models/cms/cms-self-fix-root.interface';

export const mockCmsSelfFixRoot: CmsSelfFixRoot = {
  ...mockCmsHeader,
  ...mockCmsFooter,
  ...mockCmsSeoSite,
};
